import React from 'react';
import { SpinnerContainer } from './styles';

const Spinner = ({ small }) => {
  return <SpinnerContainer small={small} />;
};

export default Spinner;
